<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1000px"
      title="查询开通记录"
      @details-opened="onDetailsOpened"
      @closed="onClosed"
      :confirm-on-close-change="false"
    >
      <template slot="form">
        <div class="filter-container">
          <el-row class="filter-top" type="flex" justify="end">
            <el-col :span="isMB?11:16">
              <span class="span-top-text" style="line-height:39px;">查询条件</span>
              <div class="searchIcon" @click="showForm = !showForm">
                <i :class="showForm?'el-icon-arrow-up':'el-icon-arrow-down'"></i>
              </div>
            </el-col>
            <el-col :span="isMB?13:8">
              <div class="btn-search">
                <el-button type="primary" icon="el-icon-search" @click="onQuery()">搜索</el-button>
                <el-button type="primary" plain @click="resetQuery">重置</el-button>
              </div>
            </el-col>
          </el-row>
          <el-row v-show="showForm">
            <el-divider style="margin:0px;"></el-divider>
            <el-form class="form-item" :class="{'form-item-left':isMB}">
              <el-form-item label="学生姓名">
                <el-input v-model="params.FullName" placeholder="请输入学生姓名" />
              </el-form-item>
            </el-form>
          </el-row>
        </div>
        <div ref="tbcontent">
          <div class="row-head">
            <span>查询结果</span>
          </div>
          <el-table v-loading="tbLoading" :data="data" border>
            <el-table-column prop="StudentNumber" label="学生编号" min-width="100px" />
            <el-table-column prop="FullName" label="学生姓名" min-width="100px" />
            <el-table-column label="开通周期" min-width="160px">
              <template slot-scope="{row}">
                <span>{{row.StartMonth}}</span>
                <span style="margin: 5px;">~</span>
                <span>{{row.EndMonth}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="TotalCharge" label="开通金额" width="100px" />
            <el-table-column prop="AddTime" label="开通时间" min-width="140px" />
          </el-table>
          <div style="height: 10px;"></div>
          <el-pagination
            :page-size.sync="params.PageSize"
            :current-page.sync="params.PageIndex"
            :page-sizes="[15,30,50,100,300]"
            layout="total, sizes, prev, pager, next"
            :total="total"
            @size-change="getData"
            @current-change="getData"
          />
        </div>
      </template>
      <template slot="footer">
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: [],
      params: {
        EduToHomeId: 0,
        SchoolId: null,
        SchoolName: "",
        // StudentId: null,
        FullName: "",
        PageSize: 10,
        PageIndex: 1,
      },
      schools: [],
      total: 0,
      tbLoading: false,
      isMB: this.$store.state.isMB,
      showForm: !this.$store.state.isMB,
      api: require("@/api/consume/edutohomestu").default,
    };
  },
  methods: {
    onDetailsOpened(data) {
      console.log("data", JSON.parse(JSON.stringify(data)));
      this.params.EduToHomeId = data.EduToHomeId;
      this.params.SchoolId = data.SchoolId;
      this.getData();
    },
    getData() {
      var params = this.$commonJs.obj.removeNullKey(this.params);
      this.tbLoading = true;
      this.api.list(params).then((res) => {
        this.tbLoading = false;
        this.total = res.Count;
        this.data = res.Data;
      });
    },
    onQuery() {
      this.params.PageIndex = 1;
      this.params.PageSize = 10;
      this.getData();
    },
    resetQuery() {
      this.params.FullName = "";
      this.params.PageIndex = 1;
      this.params.PageSize = 10;
      this.getData();
    },
    onClosed() {
      this.params.FullName = "";
      this.params.PageIndex = 1;
      this.params.PageSize = 10;
      this.data = [];
    },
  },
};
</script> 
<style lang="scss" scoped>
.row-head {
  line-height: 40px;
  color: #909399;
  padding-left: 10px;
  border: 1px solid #ebeef5;
  border-bottom: 0px;
}
</style>